import { bm } from '@skippay/core/utils/classUtils';
import React, { PropsWithChildren } from 'react';

import { Touchable } from '@skippay/core/@types/touchable';

import './index.sass';
import Link from '@skippay/core/components/Link';

const MODULE_NAME = 'NavLink';

interface Props extends Touchable {
	analyticsId: string,
	testId: string,
}

function NavLink(props: PropsWithChildren<Props>) {
	return (
		<Link
			{...props}
			activeClassName="isActive"
			textDecoration={['none', 'none']}
			className={bm(MODULE_NAME)}
		>
			{props.children}
		</Link>
	);
};

export default NavLink;
